// extracted by css-extract-rspack-plugin
export default {"modalSmall":"modalSmall-hCFe0w"};